import { mentorJobsConstants } from "../../_constants";
import axiosInstance from "../../../_helpers/axiosInstance";
import config from "../../../_config/config";
import {
  showSuccessMessage,
  showWarningMessage,
} from "../../../_uiComponents/ShowMessageSnack";

//apply job
export const apply_job_mentor_action = (id) => async (dispatch) => {
  dispatch({
    type: mentorJobsConstants.MENTOR_APPLY_JOB_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.post(
      config.mentor.applyJob.replace(":id", id)
    );
    if (response.status) {
      dispatch({
        type: mentorJobsConstants.MENTOR_APPLY_JOB_ACTION_SUCCESS,
        payload: response.data,
      });
      showSuccessMessage("Successfully Applied.");
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: mentorJobsConstants.MENTOR_APPLY_JOB_ACTION_FAILURE,
      payload: e.msg,
    });
    showWarningMessage(e?.msg);
    return e;
  }
};

// /applied job detail
export const applied_job_details_mentor_action = (id) => async (dispatch) => {
  dispatch({
    type: mentorJobsConstants.GET_MENTOR_APPLIED_JOB_DETAILS_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.get(
      config.mentor.appliedJobDetails.replace(":id", id)
    );
    if (response.status) {
      dispatch({
        type: mentorJobsConstants.GET_MENTOR_APPLIED_JOB_DETAILS_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: mentorJobsConstants.GET_MENTOR_APPLIED_JOB_DETAILS_ACTION_FAILURE,
      payload: e.msg,
    });
  }
};

//all applied jobs
export const get_applied_jobs_list_mentor_action =
  (page) => async (dispatch) => {
    dispatch({
      type: mentorJobsConstants.GET_MENTOR_APPLIED_JOBS_LIST_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        `${config.mentor.appliedJobs}?page=${page ? page : 1}`
      );
      if (response.status) {
        dispatch({
          type: mentorJobsConstants.GET_MENTOR_APPLIED_JOBS_LIST_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: mentorJobsConstants.GET_MENTOR_APPLIED_JOBS_LIST_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };
